///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, HostListener, OnInit } from '@angular/core';
import { ProjectWindowsPopupService } from '../project-windows-popup.service';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';
import { GtthImportTopologyCommand } from '../../logical-topology/engine/commands/project/import-topology-command';
import { AttachedFileDTO } from '../../../generated/shared-types.model';
import { GtthDataUtils } from '../../../services/data-util.service';
import { ActiveRestorableWindow } from '../active-restorable-window';
import { GtthUpdateMainConfigCommand } from '../../logical-topology/engine/commands/project/update-main-config-command';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'winde-import-topology-modal',
    templateUrl: './import-topology-modal.component.html',
    styleUrls: ['./import-topology-modal.scss'],
    standalone: false
})
export class GtthImportTopologyComponent extends ActiveRestorableWindow {
    public file: File;
    public fileInp;

    public isImporting = false;

    constructor(
        public dialogRef: MatDialogRef<GtthImportTopologyComponent>,
        private readonly historyService: GtthHistoryService
    ) {
        super();
    }

    fileChange(event) {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.file = fileList[0];
        }
    }

    downloadTemplate() {
        if (!this.file) {
            return;
        }

        this.isImporting = true;

        GtthDataUtils.toBase64(this.file, (base64Data) => {
            const attachedFile: AttachedFileDTO = {
                fileName: this.file.name,
                file: base64Data,
                contentType: this.file.type
            };

            const importCommand = this.historyService.command(GtthImportTopologyCommand).create(attachedFile);
            this.historyService.doCommandBypassHistory(importCommand).then(() => {
                if (!this.historyService.logicalTopology.layersModeEnabled && this.historyService.logicalTopology.hasStationsWithLayers()) {
                    this.historyService.logicalTopology.enableLayersMode(this.historyService);
                    this.historyService.projectInfoViewService.showLayers(
                        this.historyService.logicalTopology.layers,
                        this.historyService.logicalTopology.activeLayerIdx
                    );

                    this.historyService.doCommandBypassHistory(this.historyService.command(GtthUpdateMainConfigCommand)).then(() => {
                        this.historyService.notificationService.showSuccess(
                            'Layers mode enabled because imported topology has nodes mapped to layers.'
                        );
                        this.isImporting = false;
                        this.closeModal();
                    });
                } else {
                    this.isImporting = false;
                    this.closeModal();
                }
            });
        });
    }

    closeModal() {
        this.dialogRef.close('cancel');
        this.fileInp = '';
        if (this.file) {
            this.file = undefined;
        }
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardUpEvent(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.closeModal();
        }
    }

    designRequired(): boolean {
        return false;
    }

    isRestorable(): boolean {
        return true;
    }
}

@Component({
    selector: 'winde-import-topology-modal-popup',
    template: '',
    standalone: false
})
export class GtthImportTopologyPopupComponent implements OnInit {
    constructor(private readonly projectWindowsPopupService: ProjectWindowsPopupService) {}

    ngOnInit() {
        this.projectWindowsPopupService.openWindow(GtthImportTopologyComponent, 'sm');
    }
}
